import useNetwork from '@/hooks/useNetwork';
import { getNearby } from '@/pages/partners/useQuery';
import { useConnect } from '@hooks/@lore/query-connect';

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 0,
    returnCsvQuery = false } = props;

  const network = useNetwork();

  const query = {
    where: {
      filter: {
        intent: 'partner',
        siteNetwork: network?.id,
        joined: '1 week',
        nearby: getNearby(search),
      },
    },
    pagination: returnCsvQuery ? undefined : {
      page: search.page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc',
    }
  };

  const result  = useConnect('user.find', query,
    {
      keepPreviousData: true,
      enabled: !returnCsvQuery}
  );

  if (returnCsvQuery) {
    return query;
  }

  return result;
}
